<template>
  <lazy-component>
    <div class="wrapper">
      <iframe
        class="content"
        width="100%"
        height="100%"
        :src="url"
        frameborder="0"
        :allow="allow"
        allowfullscreen
      ></iframe>
    </div>
  </lazy-component>
</template>

<script>
export default {
  name: "app-twitch",
  props: {
    src: {
      type: String,
      required: true,
    },
    srctype: {
      type: String,
      default: "channel",
    },
    time: {
      default: false,
    },
    autoplay: {
      default: false,
    },
  },
  computed: {
    url() {
      return `https://player.twitch.tv/?${this.srctype}=${this.src}&parent=${window.location.hostname}`;
    },
    allow() {
      return `${
        this.autoplay === true || this.autoplay == "true" ? "autoplay;" : ""
      }`;
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;

  .content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
